module.exports = __webpack_public_path__ + "static/Corona-Banner-new-Landing.6bf8ee6b.png";